module.exports = __webpack_public_path__ + "static/media/enem-logo.59ced603.png";